<template>
  <div v-show="$store.state.loading" id="loading" >
    <div style="width: 100vw; ">
      <!-- <svg style="width: 100%; height: 100%"> -->
      <svg width="100" height="100">
        <switch>
          <g id="Group">
            <path
              class="path1"
              d="M60.97,0c-13.13,0-23.8,10.74-23.8,23.37s10.08,22.19,22.64,22.19c4.34,0,8.32-1.3,11.72-3.42-.94,7.55-3.63,14.63-9.5,20.06-9.26,8.62-21.11,8.5-33.65,8.62l-19.11,.23c.59-24.2,2.58-36.47,5.16-42.72,4.1-9.79,10.44-15.94,21.58-17.59,1.99-3.07,4.92-7.44,10.55-10.15C31.54,.59,19.11,6.02,11.14,15.94,2.11,27.27,1.17,48.74,0,79.43H31.9c24.28,0,43.04-7.08,48.43-33.64,1.87-9.2,3.51-29.86,3.63-45.79h-23Zm-1.05,37.52c-7.86,0-13.95-6.37-13.95-14.28s6.1-14.28,13.95-14.28,14.19,6.37,14.19,14.28c0,7.91-6.34,14.28-14.19,14.28Z"
            />
          </g>
        </switch>
      </svg>
    </div>
  </div>
</template>

 <script>
export default {
  name: "LoadingComponent",
};
</script>

 <style>
#Group {
  display: flex;
}
#loading {
  overflow: hidden;
  display: flex;
  background-color: #350061;
  width: 100%;
  height: 100vh;
  z-index: 10000;
  position: absolute;
  margin-top: 0px;
  align-items: center;
  justify-content: center;
}
/* .path2 {
  stroke-dasharray: 1368;
  stroke-dashoffset: 1000;
  animation: dash 4s ease-in infinite;
  stroke: #ff6101;
  stroke-width: 2px;
  fill: transparent;
} */
.path1 {
  stroke-dasharray: 794;
  stroke-dashoffset: 200;
  animation: dash2 2s linear infinite;
  stroke: #ff6101;
  stroke-width: 2px;
  fill: transparent;
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  70% {
    stroke-dashoffset: 160;
    fill: transparent;
  }
  80% {
    stroke-dashoffset: 0;
    fill: #ff6101;
  }
  100% {
    stroke-dashoffset: 0;
    fill: #ff6101;
  }
}
@keyframes dash2 {
  0% {
    stroke-dashoffset: 764;
  }
  70% {
    stroke-dashoffset: 60;
    fill: transparent;
  }
  80% {
    stroke-dashoffset: 0;
    fill: #ff6101;
  }
  100% {
    stroke-dashoffset: 0;
    fill: #ff6101;
  }
}
</style>